import styled, { css } from 'styled-components';
import { TextLabel } from '../typography/typography.styles';

export const RadioGroupContainer = styled.div``;

export const Label = styled(TextLabel)`
  font-weight: 400;
  margin-bottom: 6px;
`;

interface RadioButtonsWrapperProps {
  $direction?: 'row' | 'column';
  $gap?: string;
}

export const RadioButtonsWrapper = styled.div<RadioButtonsWrapperProps>`
  display: flex;
  gap: 24px;

  ${({ $direction = 'row' }) => {
    if ($direction === 'row') {
      return css`
        flex-direction: row;
        align-items: center;
      `;
    }

    return css`
      flex-direction: column;
      align-items: start;
    `;
  }}
`;

export const DisabledFieldset = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;

  /* Visual + interaction lock for everything inside */
  &:disabled {
    opacity: 0.5;
    pointer-events: none; /* blocks mouse */
    user-select: none; /* optional, avoid text selection */
    cursor: not-allowed;
  }
`;
